import { Either } from '@ajtec/either-typescript';
import { Article } from '../entities/article';
import { ICommunityRepository } from '../repositories/community-repository';

export class GetArticleById {
	repository: ICommunityRepository;

	constructor(communityRepository: ICommunityRepository) {
		this.repository = communityRepository;
	}

	async call(id: number, lang: string): Promise<Either<string, Article>> {
		return this.repository.getArticleById(id, lang);
	}
}
